export const SOFA_14_COLUMNS = {
  gridColumns: [
    {
      dataType: 'string',
      displayName: 'Legal Entity',
      propertyName: 'legalEntityId',
    },
    {
      dataType: 'string',
      displayName: 'Name',
      propertyName: 'name',
    },
    {
      dataType: 'string',
      displayName: 'Signature',
      propertyName: 'signature',
    },
    {
      dataType: 'string',
      displayName: 'Position',
      propertyName: 'position',
    },
    {
      dataType: 'string',
      displayName: 'Date',
      propertyName: 'date',
    },
    {
      dataType: 'string',
      displayName: 'Additional Pages Attached',
      propertyName: 'additionalPagesAttached',
    },

    {
      dataType: 'string',
      displayName: 'Footnote',
      propertyName: 'footnote',
    },
    {
      dataType: 'string',
      displayName: 'Entity Comments',
      propertyName: 'entityComments',
    },
  ],
};
